<template>
  <b-container class="py-4">
    <b-row style="height: 100%">
      <b-col
        md="8"
      >
        <b-card
          title="Informações Cadastrais"
        >
          <customer
            :lead-id="registerOnlineData.lead_id"
            :name="registerOnlineData.name"
            :company-name="registerOnlineData.company_name"
            :company-type="registerOnlineData.company_type"
            :tax-id="registerOnlineData.document"
            :phone="registerOnlineData.phone"
            :email="registerOnlineData.email"
            :monthly-income="registerOnlineData.monthly_income"
          />
        </b-card>
      </b-col>

      <b-col
        md="4"
      >
        <b-card
          v-if="registerOnlineData.products"
          title="Soluções Associadas"
        >
          <products :products="registerOnlineData.products" />
        </b-card>
      </b-col>

      <b-col
        md="8"
      >
        <Address
          class="p-0"
          style="height: 100%"
          :address="registerOnlineData.address"
        />
      </b-col>
      <b-col
        v-if="registerOnlineFiles"
        md="8"
      >

        <files
          :data="registerOnlineData"
          :register="registerOnlineFiles"
          @upload="sendFiles"
        />
      </b-col>

    </b-row>
  </b-container>
</template>

<script>
import {
  BContainer,
  BCard,
  BRow,
  BCol,
} from 'bootstrap-vue'

import Address from '@/layouts/components/DetailsTransaction/AddressCard.vue'
import { callLoading } from '@/service/utilities/utilities'
import {
  findByHash, uploadAllFiles, userLink,
} from '@/service/online-registration'

import Customer from './components/Customer.vue'
import Products from './components/Products.vue'
import Files from './components/Files/Files.vue'

import '@validations'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BContainer,
    Customer,
    Products,
    Address,
    Files,

  },

  data() {
    return {
      registerOnlineData: {
        address: {},
      },
      hash: this.$route.params.hash,
      userFileBySelectedProducts: [],
      sendedFiles: [],
      optionalFilesProducts: [],
      products: [],
      registerOnlineFiles: null,
    }
  },

  async created() {
    this.findRegisterByHash()

    if (this.registerOnlineData.status_id === 21) {
      this.$bvModal
        .msgBoxConfirm('Lead foi criado mas o envio dos arquivos falhou, tente novamente', {
          okTitle: 'Confirmar',
          cancelTitle: 'Voltar',
          cancelVariant: 'outline-secondary',
        })
    }
  },

  methods: {

    async findRegisterByHash() {
      callLoading(true)
      const { status, data } = await findByHash(this.hash)

      this.registerOnlineData = data.registration
      if (this.registerOnlineData.status_id === 2 || this.registerOnlineData.status_id === 5 || status !== 200) this.$router.push('/error-404')
      this.registerOnlineFiles = data.files

      if (data.files.denied_files.length) {
        this.$bvModal
          .msgBoxConfirm('Alguns dos seus arquivos foram negados.', {
            okTitle: 'Confirmar',
            cancelTitle: 'Voltar',
            cancelVariant: 'outline-secondary',
          })
      }

      callLoading(false)
    },

    async sendFiles(files) {
      const isActionConfirmed = await this.$bvModal
        .msgBoxConfirm('Deseja mesmo mandar os seus dados para análise?', {
          cancelVariant: 'outline-secondary',
          centered: true,
          okTitle: 'Sim',
          cancelTitle: 'Não',
        })

      if (!isActionConfirmed) {
        return
      }

      callLoading(true)
      if (!this.registerOnlineData.lead_id) {
        await userLink({}, this.hash)
      }
      await uploadAllFiles(files, this.hash)

      document.location.reload()
      callLoading(false)
    },
  },
}
</script>
